export const actionTypes = {
    FETCHING_START: "FETCHING_START",
    FETCHING_SUCCESS:"FETCHING_SUCCESS",
    FETCHING_ERROR: "FETCHING_ERROR",
    ADD_TO_CARD: "ADD_TO_CARD",
    REMOVE_FROM_CART: "REMOVE_FROM_CART",
    INCREASE: "INCREASE",
    DECREASE: "DECREASE",
    CLEAR_CART: "CLEAR_CART"
};